import axios from "axios";

export const api = axios.create({ baseURL: process.env.REACT_APP_API_BASE });

export const errMsg = (e, fallback = "Došlo je do greške. Pokušajte ponovo.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
};

export const formatPrice = (p) => `${Number(p.amount_eur).toFixed(2)}€`;
export const planNote = (p) => (p.days ? `Pristup na ${Math.round(p.days / 30)} meseci` : "Jednokratno, bez isteka");
export const siteLabel = (url) => url.replace(/^https?:\/\//, "");
